<template>
  <ul class="chart">
    <li class="question">
      <div class="icon">
        <img src="../images/pic_tx_zf.png" alt="提问的人" />
      </div>
      <div class="content">{{ record.content ?? '--' }}</div>
    </li>
    <li class="answer">
      <div class="icon">
        <img src="../images/pic_tx_ai.png" alt="回答的人" />
      </div>
      <div class="content">
        <div class="tip">好的，结合您的问题，已为您生成调度建议如下： </div>
        <div class="detail ai-answer" v-html="record[field]"></div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      default: () => {},
    },
    field: {
      type: String,
      default: 'answer', // answer,deepThink
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.chart {
  > li {
    display: flex;
    flex-direction: row;
    gap: vw(16);
    margin: vh(30) 0;
    .icon {
      width: vw(48);
      height: vh(48);
      font-size: 0;
      border-radius: 50%;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .content {
      flex: 1;
    }
    &.question {
      flex-direction: row-reverse;
      width: 60%;
      float: right;
      .content {
        background-color: #004e2c;
        font-size: fontSize(14);
        padding: vh(16) vw(16);
        border-radius: vh(16);
      }
    }
    &.answer {
      float: none;
      clear: both;
      .content {
        .tip {
          font-size: fontSize(16);
          padding-bottom: 1em;
          border-bottom: 1px solid #004e2c;
          line-height: 1;
          color: #ffffffcc;
        }
        .detail {
        }
      }
    }
  }
}
</style>
